
export const AbsenceNames = [
	{id: 1, name: "Congés: Annuels"},
	{id: 2, name: "Congés exceptionnels"},
	{id: 3, name: "Report"},
	{id: 4, name: "Maladie (avec certificat médical)"},
	{id: 5, name: "Raisons Familiales"},
	{id: 6, name: "Congé Maternité"},
	{id: 7, name: "Accueil (Adoption)"},
	{id: 8, name: "Accompagnement (Soins pallia.)"},
	{id: 9, name: "Accident de travail"},
	{id: 10, name: "Disp. enceinte et allaitante"},
	{id: 11, name: "Visite Medicale"},
	{id: 12, name: "Récupération de Solde (Hrs. Supl.)"},
	{id: 13, name: "Formation"},
	{id: 14, name: "Congé (Jours férié à récupérer)"},
	{id: 15, name: "Crédit férié"},
	{id: 16, name: "Congé jeunesse"},
	{id: 17, name: "Congé formation MEN"},
	{id: 18, name: "Crédit congé formation MEN"},
	{id: 19, name: "(Maladie (sans certificat médical)"},
	{id: 20, name: "Crédit de Solde (Hrs. Supl.)"},
	{id: 21, name: "Pont"},
	{id: 22, name: "DebitFerie(sYS)"},
	{id: 23, name: "Supervision"},
	{id: 24, name: "Raisons Familiales Extraordinaire"},
	{id: 38, name: "Don de sang/Plasma"},
	{id: 39, name: "Concé Exceptionnel (Engag. Assoc, etc"},
	{id: 40, name: "Congés Offerts"}
];


export function getAbsenceName(id: number): string {

	const cat = AbsenceNames.find(n => n.id == id);

	if (!cat)
		return "Absence";

	return cat.name;
}
